export default __webpack_public_path__ + "../images/news-tile-3.jpg";